import React, { useRef } from 'react';
import { SvgStyle } from './Seat.styles';
import PropTypes from 'prop-types';

const Seat = ({ isErSeat = false, dataStatus = '' }) => {
  const svgRef = useRef(null);

  return (
    <SvgStyle
      ref={svgRef}
      key={`${dataStatus}_${Number(isErSeat)}`}
      data-testid="seat"
      data-cy="seat"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      isErSeat={isErSeat}
    >
      <g transform="matrix(1,0,0,1,-46,-1)">
        <g className="c-seat c-seat--available" data-status={dataStatus} transform="matrix(0.666334,0,0,0.666334,15.3486,0.333666)">
          <path className="c-seat__background" d="M46,1L91,1L91,46L46,46L46,1Z" fill="currentColor" />
          <path
            className="c-seat__seat-element"
            d="M57.557,36L63.465,34.259L77.424,34.259C79.386,34.259 83.437,31.11 83.437,23.741C83.437,16.371 79.386,13.222 77.424,13.222L63.465,13.222L57.557,11.48C55.519,11.48 53.852,13.371 53.852,15.68L53.852,31.801C53.852,34.111 55.519,36 57.557,36Z"
            fill="currentColor"
          />
          <path
            className="c-seat__seat-element"
            d="M69.732,10.42C69.732,9.639 69.23,9 68.618,9L58.231,9C57.38,9 56.683,9.887 56.683,10.972L56.683,12.028C56.683,12.178 59.889,13.045 60.005,13.045L68.618,12.3C69.23,12.3 69.732,11.661 69.732,10.88L69.732,10.42ZM69.732,36.738C69.732,37.591 69.23,38.288 68.618,38.288L58.231,38.288C57.38,38.288 56.683,37.32 56.683,36.136L56.683,34.983C56.683,34.821 58.892,33.875 59.009,33.875L68.618,34.687C69.23,34.687 69.732,35.385 69.732,36.236L69.732,36.738Z"
            fill="currentColor"
          />
          <line
            className="c-seat__line"
            x1="47.00"
            y1="45.00"
            x2="91.00"
            y2="1.00"
            strokeWidth="1"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </g>
      </g>
    </SvgStyle>
  );
};

Seat.propTypes = {
  isErSeat: PropTypes.bool,
  dataStatus: PropTypes.string
};

export default Seat;
